<script>
import { mapActions, mapGetters } from 'vuex'
import {COUNTRY_ARRIVO, REPARTO_NAME} from '../../utils/config'
import {makeDays} from '../../store/modules/itinerario/actions/utils'

export default {
  name: 'ServiziAction',
  methods: {
    ...mapActions(['removeTrasferimenti', 'addReplaceServizio', 'loadTrasferimenti', 'addTrasferimento']),
    ...mapGetters(['getItinerario', 'getFlightFromLastDate']),

    loadTrasferimentiFixed (codiciTrasferimenti, search) {
      // resetta tutti i trasferimenti
      this.removeTrasferimenti()

      // carica l'andata
      if (codiciTrasferimenti && codiciTrasferimenti.codiceAndata) {
        const dateSelected = this.getFlightFromLastDate()
        const trasferimentoAndata = this.$store.getters.getTrasferimentoByProductId(codiciTrasferimenti.codiceAndata)
        if (typeof trasferimentoAndata !== 'undefined') {
          trasferimentoAndata.groups.forEach(group => { group.dateSelected = dateSelected })
          const payloadAndata = {...trasferimentoAndata, isAndata: true, groups: trasferimentoAndata.groups, isTrasferimento: true, isTrasferimentoFisso: true}
          this.addReplaceServizio(payloadAndata)
        } else {
          console.log('Attenzione! trasferimento andata non trovato: ', codiciTrasferimenti.codiceAndata)
        }
      }
      // carica il ritorno
      if (codiciTrasferimenti && codiciTrasferimenti.codiceRitorno) {
        const days = makeDays(search)
        const trasferimentoRitorno = this.$store.getters.getTrasferimentoByProductId(codiciTrasferimenti.codiceRitorno)
        if (typeof trasferimentoRitorno !== 'undefined') {
          trasferimentoRitorno.groups.forEach(group => { group.dateSelected = days[days.length - 1].day })
          const payloadRitorno = {...trasferimentoRitorno, isAndata: false, groups: trasferimentoRitorno.groups, isTrasferimento: true, isTrasferimentoFisso: true}
          this.addReplaceServizio(payloadRitorno)
        } else {
          console.log('Attenzione! trasferimento ritorno non trovato: ', codiciTrasferimenti.codiceRitorno)
        }
      }
    },
    getAllServiziToSearch () {
      // servizi configurati
      const servizi = this.$store.getters.getServizi.list.map(item => {
        return {locationId: {countryCode: COUNTRY_ARRIVO, provider: item.fornitore.name, code: item.codice.trim()}, days: item.days}
      })
      // trasferimenti hotels
      const allDays = [true, true, true, true, true, true, true]
      const trasferimentiHotels = []
      const list = this.$store.getters.getHotels.list
      const listCodiciAndata = [...new Set(list.filter(item => item.codiceAndata != null && item.codiceAndata !== '').map(item => item.codiceAndata.trim()))]
      const listCodiciRitorno = [...new Set(list.filter(item => item.codiceRitorno != null && item.codiceRitorno !== '').map(item => item.codiceRitorno.trim()))]
      listCodiciAndata.forEach(codiceAndata => trasferimentiHotels.push({locationId: {countryCode: COUNTRY_ARRIVO, provider: REPARTO_NAME, code: codiceAndata}, days: allDays}))
      listCodiciRitorno.forEach(codiceRitorno => trasferimentiHotels.push({locationId: {countryCode: COUNTRY_ARRIVO, provider: REPARTO_NAME, code: codiceRitorno}, days: allDays}))
      /*
      this.$store.getters.getHotels.list.forEach(hotel => {
        if (hotel.isTrasferimentoObbligatorio) {
          const codiceAndata = hotel.codiceAndata.trim()
          const codiceRitorno = hotel.codiceRitorno.trim()
          trasferimentiHotels.push({locationId: {countryCode: COUNTRY_ARRIVO, provider: REPARTO_NAME, code: codiceAndata}, days: allDays})
          if (codiceAndata !== codiceRitorno) {
            trasferimentiHotels.push({locationId: {countryCode: COUNTRY_ARRIVO, provider: REPARTO_NAME, code: codiceRitorno}, days: allDays})
          }
        }
      })
      */
      return [...servizi, ...trasferimentiHotels]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/actions/ServiziAction.vue